module.exports = __webpack_public_path__ + "static/GCMobile-4ba08a4fad42a26deee88f1bad6730ea.pdf";